module.exports = __webpack_public_path__ + "img/hero_imagetop.27e524a0.png";